import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { Box, Button, ErrorMsg, Grid, Text } from "atoms";
import { FormInput } from "molecules/FormInput";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
});

export const SendEmailForm = ({ onSubmit, loading, error, resetError }) => {
  const navigate = useNavigate();
  return (
    <Box>
      <Text
        fontSize="2rem"
        color="primary.900"
        fontFamily="NeometricBold"
        mb="2rem"
      >
        Reset Password
      </Text>
      <Text fontSize="1.6rem" color="neutral.800" mb="4rem">
        A 4-digit OTP will be sent to the email mentioned below
      </Text>
      <Formik
        initialValues={{
          email: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ setFieldValue }) => {
          return (
            <Form>
              <Grid gridGap="2.4rem">
                <FormInput
                  name="email"
                  type="text"
                  placeholder="Email*"
                  onChange={(e) => {
                    setFieldValue("email", e?.target?.value);
                    error && resetError();
                  }}
                />
                {error && <ErrorMsg text={error} />}
                <Button
                  my="2rem"
                  width="100%"
                  variant="primary"
                  height="4.8rem"
                  type="submit"
                  loading={loading}
                >
                  Reset
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
      <Box>
        <Text
          fontSize="1.6rem"
          color="neutral.800"
          fontFamily="NeometricMedium"
          textAlign="center"
        >
          Remember it? &nbsp;
          <Text
            as="span"
            color="secondary.700"
            cursor="pointer"
            onClick={() => navigate("/login")}
          >
            Log In
          </Text>
        </Text>
      </Box>
    </Box>
  );
};
